// The client half of the approval gate (exported on the api object from
// common/src/index.js, next to the onboarding helpers).
//
// Same rule as the server (functions/common/approvalGate.js) and the database
// rules (bookings/$bookingid/driver and /customer): while
// settings.approvalGateEnabled is true, a driver may take or start trips and a
// customer may book or join trips only when the profile says approved === true.
// This check only gives a clear message early; the server and the rules are
// what enforce it, for old app builds too.
//
// Works offline: it reads the profile and settings the phone already has (the
// Offline Meter passes its cached profile and cached settings).

export const approvalGateOn = (settings) => !!(settings && settings.approvalGateEnabled === true);

// The signed-in account itself. null = allowed; otherwise the key of the
// bundled string to show (mobile-app/src/i18n/gates). Staff roles are never
// blocked here.
export const ownAccountBlock = (profile, settings) => {
    if (!approvalGateOn(settings) || !profile || profile.approved === true) return null;
    if (profile.usertype === 'driver') return 'gate_driver_not_approved';
    if (profile.usertype === 'customer') return 'gate_rider_on_hold';
    return null;
};

// A driver a customer looked up (the check_profile_exists result `res` and the
// driver record in it). requireOnline: true for "book this driver now",
// false for joining a meter / shared trip that is already running.
export const lookedUpDriverBlock = (res, driver, settings, requireOnline) => {
    if (res && res.notBookable === 'driver_not_approved') return 'gate_driver_cannot_take_rides';
    if (!approvalGateOn(settings) || !driver) return null;
    if (driver.approved !== true) return 'gate_driver_cannot_take_rides';
    if (requireOnline !== false && driver.driverActiveStatus !== true) return 'gate_driver_offline';
    return null;
};

// The office number shown in the message (the existing strings already say
// 9260; settings.CompanyPhone wins when it is set).
export const officePhone = (settings) => String((settings && settings.CompanyPhone) || '9260');
